import STATUS_CODE from "../../base/constants/statusCodes";
import { UNAUTORIZED_STRING } from "@/base/constants/headers";
import { memoizedSendRefreshToken } from "../refreshSession";
import { mapResponse } from "./mapResponse";
import routes from "../../const/routes";
import axios from "axios";

function redirectToLogout() {
  let location = window.location;
  location.href = `${location.origin}${routes.LOGOUT()}`;
}

export const RefreshSessionInterceptor = (error, requestCache) => {
  let dataObject = {},
    statusCode;
  const { response } = error;
  const { UNAUTHORIZED } = STATUS_CODE;

  if (response) {
    dataObject = response.data;
  }

  statusCode =
    dataObject.code || dataObject.statusCode || (response && response.status);

  const isUnauth =
    statusCode === UNAUTHORIZED || statusCode === UNAUTORIZED_STRING;
  if (isUnauth) {
    return memoizedSendRefreshToken()
      .then((newAccessToken) => {
        // retry request
        error.config.headers.Authorization = `Bearer ${newAccessToken}`;

        return axios
          .request(error.config)
          .then((r) => mapResponse(r, requestCache));
      })
      .catch((err) => {
        redirectToLogout();
        throw err;
      });
  }

  return Promise.reject(dataObject);
};
